import colors from "../../Theme/base/colors";
import pxToRem from "../../Theme/functions/pxToRem";

const { background, text, brand } = colors;

export default {
  base: {
    // backgroundColor: background.default,
    minHeight: pxToRem(40),
    color: `${text.labelBrand}`,
    boxShadow: "none",
    padding: `${pxToRem(10)} ${pxToRem(24)}`,
    borderRadius: "6px !important",
    "&:hover": {
      backgroundColor: background.SideNav,
      border: "none",
      boxShadow: "none",
    },

    "&:focus": {
      boxShadow: "none",
      backgroundColor: "#fff",
    },

    "&:active, &:active:focus, &:active:hover": {
      opacity: 0.85,
      boxShadow: "none",
    },

    "&:disabled": {
      boxShadow: "none",
    },

    "& .material-icon, .material-icons-round, svg": {
      fontSize: `${pxToRem(16)} !important`,
    },
  },

  small: {
    minHeight: pxToRem(28),

    padding: `10px 20px 10px 20px`,
    fontSize: pxToRem(14),

    "& .material-icon, .material-icons-round, svg": {
      fontSize: `${pxToRem(12)} !important`,
    },
  },

  large: {
    minHeight: pxToRem(40),

    padding: `10px 24px 10px 24px`,
    fontSize: pxToRem(16),
    "& .material-icon, .material-icons-round, svg": {
      fontSize: `${pxToRem(22)} !important`,
    },
  },
  medium: {
    minHeight: pxToRem(36),

    padding: `10px 24px 10px 24px`,
    fontSize: pxToRem(14),

    "& .material-icon, .material-icons-round, svg": {
      fontSize: `${pxToRem(12)} !important`,
    },
  },

  fullWidth: {
    minHeight: "3rem",
    width: "100%",
    padding: `0`,
    fontSize: pxToRem(16),

    "& .material-icon, .material-icons-round, svg": {
      fontSize: `${pxToRem(22)} !important`,
    },
  },

  primary: {
    color: `${text.labelBrand}`,
    border: "none",
    "&:hover": {
      color: text.labelBrand,
      backgroundColor: background.SideNav,
    },

    "&:focus:not(:hover)": {
      color: text.labelBrand,
      // backgroundColor: brand.light,
      boxShadow: "none",
    },
  },

  secondary: {
    color: text.secondary,
    border: "none",
    "&:hover": {
      color: text.labelBrand,
    },

    "&:focus:not(:hover)": {
      color: text.labelBrand,
      boxShadow: "none",
    },
  },
};
